import {Component, ViewChild, ViewContainerRef} from '@angular/core';
import {PoNode} from '../po-node/ponode.model';
import {DomService} from '../../../../services/dom-service/dom.service';
import {DetailScreensService} from '../../detail-screens-module/services/detail-screens-service';
import {SpecificsLabelWrapper} from '../po-node/specifics-label-wrapper.model';
import {SpecificsLabel} from '../po-node/specifics-label.model';
import {DetailScreenComponent} from '../../detail-screens-module/detail-screen/detail-screen.component';
import {ToasterService} from '../../../../toaster-module/toaster-service/toaster.service';
import {TooltipPosition} from '@angular/material/tooltip';
import {ProductOverviewRequest} from '../../../../services/product-overview/product-overview-request.model';
import {PopupService} from '../../popup-component/popup.service/popup.service';
import {URL_BOC} from './arrangement-level.constants';
import {Subscription} from 'rxjs';
import {UiHelperService} from '../../../../services/shared/helpers/ui-helper.service';
import {MAT_TOOLTIP_DEFAULT_OPTIONS} from '@angular/material/tooltip';
import {MatTooltipDefaultOptions} from '@angular/material/tooltip';

/** Custom options the configure the tooltip's default show/hide delays. */
export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 1000,
  hideDelay: 1000,
  touchendHideDelay: 1000,
};

@Component({
  selector: 'app-arrangement-level',
  templateUrl: './arrangement-level.component.html',
  styleUrls: ['../po-node/ponode.component.css'],
  providers: [
    {provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults},
  ],
})

export class ArrangementLevelComponent {
  @ViewChild('po_node', {read: ViewContainerRef}) nodeContainer: ViewContainerRef;

  data: PoNode;
  secondDetailsComponent: DetailScreenComponent;
  expanded: boolean;
  childrenInitialized = false;
  children: ArrangementLevelComponent[] = [];
  hierarchyChildren: any[];
  isLastChild: boolean;
  nodeLevel;
  detailsComponent: DetailScreenComponent;
  expandable: boolean;
  nodeType;
  toolTipPosition: TooltipPosition = 'above';
  isBalanceToggle: boolean;
  _balanceToggleSubscription: Subscription = new Subscription();
  hasOtherLinks = ['02', '03', '04'];

  private newScreens = ['tradeagreement', 'dienstverleningsovereenkomst', 'bankguarantee', 'zekervoorjepersoneel',
    'samenstelling', 'financiallease', 'composedaccount', 'debetcarddetails', 'debitcard', 'creditcarddetails', 'omnikassa',
    'onlinekeyarrangement', 'onlinekeys', 'internationalcashmanagement', 'icm', 'exportloc', 'importloc', 'exportcollection',
    'importcollection', 'consumptievefinanciering', 'idealprofile', 'sparendeposito', 'sparen', 'icmasbabonnement', 'volmacht', 'rekeningcourant'];

  private URI = {
    tradeagreement: 'tradeagreement',
    dienstverleningsovereenkomst: 'dienstverleningsovereenkomst',
    bankguarantee: 'bankguarantee',
    zekervoorjepersoneel: 'zekervoorjepersoneel',
    financiallease: 'financiallease',
    composedaccount: 'composedaccount',
    samenstelling: 'composedaccount',
    debetcarddetails: 'debitcard',
    debitcard: 'debitcard',
    creditcarddetails: 'creditcard',
    omnikassa: 'omnikassa',
    onlinekeyarrangement: 'onlinekeyarrangement',
    onlinekeys: 'onlinekeys',
    internationalcashmanagement: 'internationalcashmanagement',
    icm: 'internationalcashmanagement',
    exportloc: 'exportletterofcredit',
    importloc: 'importletterofcredit',
    exportcollection: 'exportincasso',
    importcollection: 'importincasso',
    consumptievefinanciering: 'consumptivefinance',
    idealprofile: 'idealprofile',
    sparendeposito: 'sparendeposito',
    sparen: 'sparen',
    icmasbabonnement: 'icmasbabonnement',
    volmacht: 'volmacht',
    rekeningcourant: 'rekeningcourant'
  };

  constructor(protected domService: DomService, protected detailScreensService: DetailScreensService,
              protected toasterService: ToasterService, protected popupService: PopupService,
              protected uiHelper?: UiHelperService ) {
    this.isBalanceToggle = this.uiHelper.isBalanceToggleOn;
    this._balanceToggleSubscription = this.uiHelper.balanceToggleSubject
      .subscribe((value) => {
        this.isBalanceToggle = value;
      });
  }

  onClick() {
    this.expanded = !this.expanded;
  }

  expand() {
    this.expanded = true;
  }

  collapse() {
    this.expanded = false;
  }

  countNumber(children): number {
    let number = 0;
    children.forEach((child) => {
      if (this.isCountedArrangement(child)) {
        number++;
        return number;
      }
      number += this.countNumber(child.children);
    });
    return number;
  }

  checkNumber(number) {
    if (number === 0) {
      return '';
    }
    return number;
  }

  private isCountedArrangement(child): boolean {
    return child.type !== 'HIERARCHY_TYPE' && child.data.statusCode !== '4';
  }

  createComponent(node: any, component: any) {
    if (!this.nodeContainer) {
      return null;
    }
    const viewRef = this.domService.addComponentToDOM(component, this.nodeContainer);
    const componentToReturn = viewRef.instance as typeof component;
    componentToReturn.expandable = !node.leaf;
    componentToReturn.hierarchyChildren = node.children;
    componentToReturn.data = node.data;
    componentToReturn.isLastChild = node.isLastChild;
    if (node.data.specificsLabels) {
      componentToReturn.data.specificsLabels = this.getSpecificsLabelsFromNode(node);
    }
    if (ProductOverviewRequest.productCluster !== '') {
      this.expanded = true;
    }
    componentToReturn.nodeLevel = this.nodeLevel + 1;
    componentToReturn.detailsComponent = this.detailsComponent;
    componentToReturn['secondDetailsComponent'] = this.secondDetailsComponent;
    return componentToReturn;
  }

  loadDetailPage() {
    this.detailScreensService.clearSecondDetailsScreen(this.secondDetailsComponent);
    this.addBusyCursor();
    if (this.newScreens.includes(this.data.detailsURI)) {
      const requestUrl = this.URI[this.data.detailsURI];
      this.detailScreensService.getDetailsPage(requestUrl, this.data.arrangementNumber, this.data.administrationCode,
        this.data.iban, this.data.bankCode, this.data.commercialProductTypeCode, this.data.restrictedDataViewException, this.data.relationMarketSegmentCode)
        .subscribe((resp) => {
            if (requestUrl === 'internationalcashmanagement' && resp.listOfError && resp.listOfError.length) {
              window.open(URL_BOC, '_blank');
            }
            if (requestUrl === 'omnikassa') {
              this.urlRedirection(resp);
            } else {
              this.detailsComponent.createScreen(resp, requestUrl, this.secondDetailsComponent);
            }
            this.removeBusyCursor();
          },
          (error) => {
            if (requestUrl === 'internationalcashmanagement') {
              window.open(URL_BOC, '_blank');
            }
            this.toasterService.startErrorToast([error], '', true);
            this.removeBusyCursor();
          });
    } else {
      this.handleOldDetailScreenURI();
    }
  }

  private handleOldDetailScreenURI() {
    const listOfChildArrangementNumbers: string[] = [];
    if (this.data.detailsURI === 'beleggenNoDetails.jsf') {
      this.toasterService.startToast(Infinity, 'info', ['Voor beleggen data dient FRED te worden gestart.'], true);
      this.removeBusyCursor();
    } else {
      if (this.hierarchyChildren.length !== 0) {
        this.hierarchyChildren.forEach((child) => {
          if (this.isCountedArrangement(child)) {
            listOfChildArrangementNumbers.push(child.data.arrangementNumber);
          }
        });
      }
      this.detailScreensService.getOldDetailsPage(this.data.detailsURI, this.data.arrangementNumber, this.data.administrationCode,
        this.data.commercialProductTypeCode, this.data.parentCustomerId, listOfChildArrangementNumbers)
        .subscribe((resp) => {
          const requiredRequestData = {
            arrangementNumber: this.data.arrangementNumber,
            administrationCode: this.data.administrationCode,
            relationRestrictedDataView: true,
            restrictedDataViewException: this.data.restrictedDataViewException,
          };
          this.detailsComponent.setOldDetails(resp, this.data.detailsURI, requiredRequestData);
          this.removeBusyCursor();
        });
    }
  }

  private getSpecificsLabelsFromNode(node: any): string {
    const labelsFromResponse = Array.isArray(node?.data?.specificsLabels)
      ? node.data.specificsLabels
      : [];

    if (labelsFromResponse.length === 0) {
      return '';
    }

    const specificsLabelWrapper = new SpecificsLabelWrapper();

    labelsFromResponse.forEach((labelFromResponse) => {
      const specificsLabel = new SpecificsLabel();
      specificsLabel.labelName = labelFromResponse['labelName'];
      specificsLabel.labelValue = labelFromResponse['labelValue'];
      specificsLabelWrapper.specificsLabels.push(specificsLabel);
    });

    return specificsLabelWrapper.getAggregatedLabel();
  }

  private urlRedirection(response): void {
    const decodedUrl = atob(response.omnikassaURL);
    window.open(decodedUrl, '_blank');
  }

  public loadProductOverviewPopUp() {
    const requiredRequestData = {
      arrangementNumber: this.data.arrangementNumber,
      administrationCode: this.data.administrationCode,
      relationRestrictedDataView: true,
      restrictedDataViewException: this.data.restrictedDataViewException,
      relationMarketSegmentCode: this.data.relationMarketSegmentCode,
      commercialProductTypeCode: this.data.commercialProductTypeCode,
      parameterToken: ProductOverviewRequest.parametersToken,
      orgYN: ProductOverviewRequest.orgYN,
    };
    this.popupService.openPopup('productservices', requiredRequestData);
  }

  getAmount(amount) {
    const value = amount.totalAmount;
    const suffix = amount.totalAmount ? amount.totalAmountSuffix : null;
    return `${value}, ${suffix}`;
  }

  loadProductServicesRequiredData() {
    return {
      arrangementNumber: this.data.arrangementNumber,
      administrationCode: this.data.administrationCode,
      commercialProductTypeCode: this.data.commercialProductTypeCode,
      relationRestrictedDataView: true,
      restrictedDataViewException: this.data.restrictedDataViewException,
      relationMarketSegmentCode: this.data.relationMarketSegmentCode,
      parametersToken: ProductOverviewRequest.parametersToken,
      orgYN: ProductOverviewRequest.orgYN,
    };
  }

  getArrangementUrl() {
  }

  addBusyCursor() {
    document.body.classList.add('busy-cursor');
  }

  removeBusyCursor() {
    document.body.classList.remove('busy-cursor');
  }

  public logHoverAmount() {
    return this.data.restrictedData;
  }

}
